var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_944_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 0.480469C5.63807 0.480469 0.480469 5.63807 0.480469 12.0005C0.480469 18.3629 5.63807 23.5205 12.0005 23.5205C18.3629 23.5205 23.5205 18.3629 23.5205 12.0005C23.5205 5.63807 18.3629 0.480469 12.0005 0.480469ZM9.18047 16.7753H6.84767V9.26807H9.18047V16.7753ZM7.99967 8.34647C7.26287 8.34647 6.78647 7.82447 6.78647 7.17887C6.78647 6.52007 7.27727 6.01367 8.02967 6.01367C8.78207 6.01367 9.24287 6.52007 9.25727 7.17887C9.25727 7.82447 8.78207 8.34647 7.99967 8.34647ZM17.7005 16.7753H15.3677V12.6149C15.3677 11.6465 15.0293 10.9889 14.1857 10.9889C13.5413 10.9889 13.1585 11.4341 12.9893 11.8625C12.9269 12.0149 12.9113 12.2309 12.9113 12.4457V16.7741H10.5773V11.6621C10.5773 10.7249 10.5473 9.94127 10.5161 9.26687H12.5429L12.6497 10.3097H12.6965C13.0037 9.82007 13.7561 9.09767 15.0149 9.09767C16.5497 9.09767 17.7005 10.1261 17.7005 12.3365V16.7753Z",
    fill: "#0077B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_944_208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinIcon);
export default __webpack_public_path__ + "static/media/linkdin_icon.a74ec2199387694b63651993a216243c.svg";
export { ForwardRef as ReactComponent };